import React from 'react';
import styled from 'styled-components';

const PreferenceContainer = styled.div`
  background-color: #1a1a1a;
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
  border: 1px solid #333;
`;

const PreferenceTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 12px;
  color: #D4AF37;
  font-size: 16px;
`;

const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
`;

const OptionButton = styled.button`
  padding: 10px;
  background-color: #222;
  color: white;
  border: 1px solid #444;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #333;
    border-color: #D4AF37;
  }
  
  &.selected {
    background-color: #D4AF37;
    color: black;
    border-color: #D4AF37;
  }
`;

const PreferenceQuestion = ({ question, options, onSelect }) => {
  return (
    <PreferenceContainer>
      <PreferenceTitle>{question}</PreferenceTitle>
      <OptionsGrid>
        {options.map((option) => (
          <OptionButton
            key={option.id}
            onClick={() => onSelect(option.id)}
          >
            {option.label}
          </OptionButton>
        ))}
      </OptionsGrid>
    </PreferenceContainer>
  );
};

export default PreferenceQuestion;